import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionDefinitionContainerModel } from '../../../../../models';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService } from '../shared';
import { Core2Config } from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class TenantPermissionAssigneeTargetLinkService extends BaseApiTemplateService<PermissionDefinitionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX +'permission-assignee-target';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';
    this.httpClient = http;
  }

  addPermSetListing(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/create-assignee-perm/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  addPermSetListingV2(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/handle-all/create-assignee-perm/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  deletePermSetListing(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/delete-assignee-perm/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getPermDefinition(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/get-assignee-perm/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  addMultiplePermSet(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/multiple";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  // core2/tnt/dm/permission-assignee-target/maintain/assignee-perm/backoffice-ep
  maintainByRoles(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/maintain/assignee-perm/" + BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );

  }

}